<lumiron-section>
  <lumiron-section-header>
    <lumiron-section-title>Regional verankert</lumiron-section-title>
    <lumiron-section-summary
      >Lerne uns kennen: Dein Partner für unvergessliche Bubble Soccer Events!</lumiron-section-summary
    >
  </lumiron-section-header>
</lumiron-section>

<lumiron-section class="persons">
  <lumiron-section-body>
    <div class="person luca">
      <img
        [ngSrc]="'portrait-luca_mqyphh'"
        width="400"
        height="600"
        sizes="(min-width: 1200px) 25vw, (min-width: 992px) 30vw, (min-width: 768px) 50vw, 100vw"
        priority
        placeholder
        alt="Portrait Luca Kuster"
      />
      <h3 class="name">Luca Kuster</h3>
      <p class="position">Kundenbetreuung</p>
    </div>

    <div class="person aaron">
      <img
        [ngSrc]="'portrait-aaron_czu18r'"
        width="400"
        height="600"
        sizes="(min-width: 1200px) 25vw, (min-width: 992px) 30vw, (min-width: 768px) 50vw, 100vw"
        placeholder
        alt="Portrait Aaron Zellweger"
      />
      <h3 class="name">Aaron Zellweger</h3>
      <p class="position">Technik & IT</p>
    </div>

    <div class="person mischa">
      <img
        [ngSrc]="'portrait-mischa_boyhp1'"
        width="400"
        height="600"
        sizes="(min-width: 1200px) 25vw, (min-width: 992px) 30vw, (min-width: 768px) 50vw, 100vw"
        placeholder
        alt="Portrait Mischa Büchel"
      />
      <h3 class="name">Mischa Büchel</h3>
      <p class="position">Buchhaltung & Recht</p>
    </div>

    <div class="person mario">
      <img
        [ngSrc]="'portrait-mario'"
        width="400"
        height="600"
        sizes="(min-width: 1200px) 25vw, (min-width: 992px) 30vw, (min-width: 768px) 50vw, 100vw"
        placeholder
        alt="Portrait Mario Zünd"
      />
      <h3 class="name">Mario Zünd</h3>
      <p class="position">Social Media & Marketing</p>
    </div>
  </lumiron-section-body>
</lumiron-section>

<lumiron-section class="mission" [backgroundImage]="'green-background'">
  <lumiron-section-header>
    <lumiron-section-title>Unsere Mission</lumiron-section-title>
    <lumiron-section-summary>
      Unsere Motivation, Bubble Soccer anzubieten, geht weit über den reinen Spielspass hinaus. Wir glauben fest daran,
      dass Lachen und gemeinsame Erlebnisse Menschen zusammenbringen und verbinden. Bubble Soccer bietet genau das: eine
      einzigartige Möglichkeit, sich sportlich zu betätigen, Hemmungen abzubauen und sich in einer sicheren, lustigen
      Umgebung auszutoben.
      <br />
      <br />
      Wir möchten, dass jeder, der an unseren Spielen teilnimmt, einen unvergesslichen Tag erlebt - sei es bei einem
      Kindergeburtstag, einem Teambuilding-Event oder einem lockeren Nachmittag mit Freunden. Unser Ziel ist es,
      Veranstaltungen zu schaffen, bei denen jeder Spass hat, sich niemand ausgeschlossen fühlt und die Erinnerungen an
      das Lachen und die Kollisionen noch lange nachklingen.
    </lumiron-section-summary>
  </lumiron-section-header>
</lumiron-section>
